// extracted by mini-css-extract-plugin
export default {"content":"QuestionUploadedVideo_content__M7MnN"};